import React, { useContext, useState } from "react";
import { Button, Input, DatePicker, Tooltip, Select } from "antd";
import "./AddCliente.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import * as links from "../../../../utils/links";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import question_icon from "../../../../assets/images/question.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { SERVIDOR_URL } from "../../../../utils/constants";

const AddCliente = (props) => {
  const { Option } = Select;
  const { authInfo, setDataUser, setNotiMessage } = useContext<any>(AuthContext);
  const navigate = useNavigate();
  const token = authInfo?.dataUser?.token;

  const dateFormat = "YYYY-MM-DD";
  let currentDate = moment();

  const [data, setData] = useState<any>({
    nome: "",
    email: "",
    senha: "",
    mercadoPagoToken: "",
    dataVencimento: currentDate.add(1, "years"),
    pagbankToken: "",
    pagbankEmail: "",
    tipo:""
  });

  const [errors, setErrors] = useState<any>({});
  const [isLoading, setIsLoading] = useState<any>(false);
  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const onSave = () => {
    let errorsTemp: any = {};
    if (data.nome.trim() === "") {
      errorsTemp.nome = "Este campo é obrigatório";
    }

    console.log(data.tipo)

    if (!validateEmail(data.email)) {
      errorsTemp.email = "Este campo é obrigatório";
    }
    if (!data.tipo) {
      errorsTemp.tipo = "Este campo é obrigatório";
    }
    if (data.senha.trim().length < 6) {
      errorsTemp.senha = "A senha deve possuir no mínimo 6 dígitos.";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);
    axios.post(
      `${SERVIDOR_URL}/cliente`,
      {
        nome: data.nome,
        email: data.email,
        senha: data.senha,
        mercadoPagoToken: data.mercadoPagoToken,
        dataVencimento: new Date(data.dataVencimento),
        pagbankToken: data.pagbankToken,
        pagbankEmail: data.pagbankEmail,
        tipo:data.tipo
      },
      {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      }
    ).then((res) => {
      setIsLoading(false);
      navigate(links.DASHBOARD_CLIENTES);
    }).catch((err) => {
      setIsLoading(false);

      setNotiMessage({
        type: "error",
        message: err.response?.data?.error
          ? err.response?.data?.error
          : `A sua sessão expirou, para continuar faça login novamente.`,
      });
    });
  };

  const handleGeneratePassword = () => {
    handleChange("senha", String(Math.floor(100000 + Math.random() * 9000)));
  };

  return (
    <>
      {isLoading && <LoadingAction />}
      <div className="px-page">
        <div className="px-page-header">
          <h1 className="px-page-title">Cadastro de Cliente</h1>
          <Link className="px-back-btn" to={links.DASHBOARD_CLIENTES}>
            VOLTAR
          </Link>
        </div>

        <div className="px-panel">
          <div className="px-panel-header">
            <h2 className="px-panel-title">Dados do cliente</h2>
          </div>

          <form
            className="px-form-grid"
            onSubmit={(e) => {
              e.preventDefault();
              if (!isLoading) onSave();
            }}
          >
            <div className={`px-field ${errors.nome ? "px-field-error" : ""}`}>
              <label className="px-field-label" htmlFor="nome">
                Nome
              </label>
              <Input
                placeholder={"Jukinha da Silva"}
                value={data.nome}
                id="nome"
                type="text"
                name="nome"
                autoComplete="nome"
                onChange={(event) => handleChange("nome", event.target.value)}
              />
              {errors.nome && <div className="px-field-msg">{errors.nome}</div>}
            </div>

            <div className={`px-field ${errors.email ? "px-field-error" : ""}`}>
              <label className="px-field-label" htmlFor="email">
                Email
              </label>
              <Input
                placeholder={"jukinha@gmail.com"}
                value={data.email}
                id="email"
                type="email"
                name="email"
                autoComplete="email"
                onChange={(event) => handleChange("email", event.target.value)}
              />
              {errors.email && (
                <div className="px-field-msg">{errors.email}</div>
              )}
            </div>

            <div className={`px-field ${errors.tipo ? "px-field-error" : ""}`}>
              <label className="px-field-label" htmlFor="tipo">
                Tipo de Cliente
              </label>
              <Select
                value={data.tipo || undefined}
                placeholder="Selecione o tipo"
                onChange={(event) => handleChange("tipo", event)}
              >
                <Option value="NORMAL">Normal</Option>
                <Option value="CHUVEIRO">Chuveiro</Option>
              </Select>
              {errors.tipo && <div className="px-field-msg">{errors.tipo}</div>}
            </div>

            <div className={`px-field ${errors.senha ? "px-field-error" : ""}`}>
              <div className="px-field-label">
                <label htmlFor="senha">Senha</label>
                <Button
                  className="px-btn"
                  style={{ height: 28, padding: "0 12px", fontSize: 12 }}
                  onClick={handleGeneratePassword}
                  htmlType="button"
                >
                  <FontAwesomeIcon icon={faArrowsRotate} />
                  Gerar Senha
                </Button>
              </div>
              <Input
                placeholder={"********"}
                value={data.senha}
                id="senha"
                type="text"
                name="senha"
                autoComplete="senha"
                onChange={(event) => handleChange("senha", event.target.value)}
              />
              {errors.senha && (
                <div className="px-field-msg">{errors.senha}</div>
              )}
            </div>

            <div
              className={`px-field ${
                errors.mercadoPagoToken ? "px-field-error" : ""
              }`}
            >
              <div className="px-field-label">
                <label htmlFor="mercadoPagoToken">Token Mercado Pago</label>
                <img
                  src={question_icon}
                  alt="ajuda"
                  className="px-field-help"
                  onClick={() =>
                    navigate(links.TOKEN_HELP_PAGE, {
                      state: { redirect_url: `${links.ADD_CLIENTES}` },
                    })
                  }
                />
              </div>
              <Input
                placeholder={"APPMP123123-12312-123123"}
                value={data.mercadoPagoToken}
                id="mercadoPagoToken"
                type="text"
                name="mercadoPagoToken"
                autoComplete="mercadoPagoToken"
                onChange={(event) =>
                  handleChange("mercadoPagoToken", event.target.value)
                }
              />
              {errors.mercadoPagoToken && (
                <div className="px-field-msg">{errors.mercadoPagoToken}</div>
              )}
            </div>

            <div
              className={`px-field ${
                errors.pagbankToken ? "px-field-error" : ""
              }`}
            >
              <div className="px-field-label">
                <label htmlFor="pagbankToken">Token Pagbank</label>
                <Tooltip
                  title={
                    <>
                      Acesse: <br />
                      https://pagseguro.uol.com.br/ <br />
                      Entrar <br />
                      Menu esquerdo (VENDAS) <br />
                      Plataformas e Checkout <br />
                      Clique em Integrações <br />
                      Clique no botão Gerar token
                    </>
                  }
                >
                  <img
                    src={question_icon}
                    alt="ajuda"
                    className="px-field-help"
                  />
                </Tooltip>
              </div>
              <Input
                placeholder={"Token do PagBank"}
                value={data.pagbankToken}
                id="pagbankToken"
                type="text"
                name="pagbankToken"
                autoComplete="pagbankToken"
                onChange={(event) =>
                  handleChange("pagbankToken", event.target.value)
                }
              />
              {errors.pagbankToken && (
                <div className="px-field-msg">{errors.pagbankToken}</div>
              )}
            </div>

            <div
              className={`px-field ${
                errors.pagbankEmail ? "px-field-error" : ""
              }`}
            >
              <label className="px-field-label" htmlFor="pagbankEmail">
                Email Pagbank
              </label>
              <Input
                placeholder={"email@pagbank.com"}
                value={data.pagbankEmail}
                id="pagbankEmail"
                type="email"
                name="pagbankEmail"
                autoComplete="pagbankEmail"
                onChange={(event) =>
                  handleChange("pagbankEmail", event.target.value)
                }
              />
              {errors.pagbankEmail && (
                <div className="px-field-msg">{errors.pagbankEmail}</div>
              )}
            </div>

            <div
              className={`px-field ${
                errors.dataVencimento ? "px-field-error" : ""
              }`}
            >
              <div className="px-field-label">
                <label htmlFor="dataVencimento">Data de Vencimento</label>
                <Tooltip title="A data de vencimento do cliente é uma data que após 10 dias é feito a trava das máquinas do cliente para receber pagamentos. Ideal para quem cobra mensalidade, se não definida por padrão colocamos 1 (um) ano.">
                  <img
                    src={question_icon}
                    alt="ajuda"
                    className="px-field-help"
                  />
                </Tooltip>
              </div>
              <DatePicker
                defaultValue={data.dataVencimento}
                format={dateFormat}
                id="dataVencimento"
                name="dataVencimento"
                onChange={(vl, dateString) => {
                  handleChange("dataVencimento", dateString);
                }}
              />
              {errors.dataVencimento && (
                <div className="px-field-msg">{errors.dataVencimento}</div>
              )}
            </div>
          </form>

          <div className="px-form-actions">
            <Button
              className="px-btn px-btn-primary"
              onClick={() => {
                if (!isLoading) onSave();
              }}
              disabled={isLoading}
            >
              SALVAR
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCliente;
